import axios from "axios";

// const API_URL = //'https://agrirent.softuvo.click/api/v1/admin';
//   //"http://localhost:5000/api/v1/admin";
//   "https://app.theshetu.com/api/v1/admin";
const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance with authorization header
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.accessToken) {
      config.headers.Authorization = `Bearer ${user.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, {
      email,
      password,
    });
    if (response.data.accessToken) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

const logout = () => {
  localStorage.removeItem("user");
};
const updateAdminUser = async (id, userData) => {
  try {
    const response = await apiClient.put(`/auth/edit-profile/${id}`, userData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

//get dashOverView
const getDashOverview = async () => {
  try {
    const responce = await apiClient.get("/dashboard/overview");
    return responce.data;
  } catch (error) {
    throw error;
  }
};

// Vendor and customer functions
const getVendors = async ({
  page = 1,
  limit = 10,
  itemsPerPage,
  search = "",
  startDate = "",
  endDate = "",
}) => {
  try {
    const params = {
      page,
      limit: itemsPerPage || limit,
      search,
    };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await apiClient.get("/userlisting/vendor", {
      params,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteVendor = async (id) => {
  try {
    const response = await apiClient.delete(`userlisting/vendor/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getCustomers = async ({
  page = 1,
  limit = 10,
  itemsPerPage,
  search = "",
  startDate = "",
  endDate = "",
}) => {
  try {
    const params = {
      page,
      limit: itemsPerPage || limit,
      search,
    };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await apiClient.get("/userlisting/customer", {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteCustomer = async (id) => {
  try {
    const response = await apiClient.delete(`userlisting/customer/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Update User Active Status (Block / Unblock)
const updateUserStatus = async (id, blacklist) => {
  try {
    const response = await apiClient.put(`/userListing/status/${id}`, {
      blacklist,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Equipment API functions
const getEquipmentCategories = async ({ page = 1, limit = 10, startDate = "", endDate = "", search = "" } = {}) => {
  try {
    const params = { page, limit, search };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await apiClient.get("/equipment/categories", {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const createEquipmentCategory = async (categoryData) => {
  try {
    let response;
    if (categoryData instanceof FormData) {
      response = await apiClient.post("/equipment/categories", categoryData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    } else {
      response = await apiClient.post("/equipment/categories", categoryData);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateEquipmentCategory = async (id, categoryData) => {
  try {
    let response;
    if (categoryData instanceof FormData) {
      response = await apiClient.put(
        `/equipment/categories/${id}`,
        categoryData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    } else {
      response = await apiClient.put(
        `/equipment/categories/${id}`,
        categoryData
      );
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteEquipmentCategory = async (id) => {
  try {
    const response = await apiClient.delete(`/equipment/categories/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getManufacturers = async ({ page = 1, limit = 10, startDate = "", endDate = "", search = "" } = {}) => {
  try {
    const params = { page, limit, search };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await apiClient.get("/equipment/manufacturers", {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const createManufacturer = async (manufacturerData) => {
  try {
    const response = await apiClient.post(
      "/equipment/manufacturers",
      manufacturerData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateManufacturer = async (id, manufacturerData) => {
  try {
    const response = await apiClient.put(
      `/equipment/manufacturers/${id}`,
      manufacturerData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteManufacturer = async (id) => {
  try {
    const response = await apiClient.delete(`/equipment/manufacturers/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getVariants = async ({ manufacturerId = null, page = 1, limit = 10, startDate = "", endDate = "", search = "" } = {}) => {
  try {
    const params = { page, limit, search };
    if (manufacturerId) params.manufacturerId = manufacturerId;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await apiClient.get("/equipment/variants", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const createVariant = async (variantData) => {
  try {
    const response = await apiClient.post("/equipment/variants", variantData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateVariant = async (id, variantData) => {
  try {
    const response = await apiClient.put(
      `/equipment/variants/${id}`,
      variantData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteVariant = async (id) => {
  try {
    const response = await apiClient.delete(`/equipment/variants/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// KYC APIs
const getDoneVendorKyc = async ({ page, limit, search, status }) => {
  const response = await apiClient.get("/kyc/vendor-kyc/done", {
    params: { page, limit, search, status },
  });
  return response.data;
};

const updateVendorKycStatus = async (vendorId, data) => {
  const response = await apiClient.patch(`/kyc/vendor-kyc/${vendorId}`, data);
  return response.data;
};

const getDoneEquipmentKyc = async ({ page, limit, search, status }) => {
  const response = await apiClient.get("/kyc/equipment-kyc/done", {
    params: { page, limit, search, status },
  });
  return response.data;
};

const updateEquipmentKycStatus = async (equipmentId, data) => {
  const response = await apiClient.patch(
    `/kyc/equipment-kyc/${equipmentId}`,
    data
  );
  return response.data;
};

// Job APIs
const getAllJobs = async ({
  page = 1,
  limit = 20,
  search = "",
  status = "",
  startDate = "",
  endDate = "",
} = {}) => {
  try {
    const params = { page, limit, search, status };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await apiClient.get("/jobs/all-jobs", {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get All Referrals
const getDiscount = async () => {
  try {
    const response = await apiClient.get(`/refferal/get-discount`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Add Referral Discount
const addReferralDiscount = async (
  discountType,
  discountValue,
  expiryType,
  expiryDays
) => {
  try {
    const response = await apiClient.post(`/refferal/add-discount`, {
      discountType,
      discountValue,
      expiryType,
      expiryDays,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Referral Discount
const updateReferralDiscount = async (
  id,
  discountType,
  discountValue,
  expiryType,
  expiryDays
) => {
  try {
    const response = await apiClient.put(`/refferal/update-discount/${id}`, {
      discountType,
      discountValue,
      expiryType,
      expiryDays,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get All Referrals
const getAllReferrals = async () => {
  try {
    const response = await apiClient.get(`/refferal`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
const newgetAllReferrals = async ({ page = 1, limit = 10, search = "" }) => {
  try {
    const response = await apiClient.get(`/refferal/refferal-details`, {
      params: {
        page,
        limit,
        search,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
const newupdateReferralDiscount = async (id, data) => {
  try {
    const response = await apiClient.put(`/refferal/update/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete Referral by ID
const deleteReferralById = async (id) => {
  try {
    const response = await apiClient.delete(`/refferal/users/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get All Payments
const getAllPaidJobs = async ({
  page = 1,
  limit = 10,
  search = "",
  status = "",
  startDate = "",
  endDate = "",
} = {}) => {
  try {
    const params = { page, limit, search, status };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await apiClient.get("/jobs/paid", {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// add commission
const addCommission = async (commissionType, typeValue) => {
  try {
    const response = await apiClient.post(`/commission/add-commission`, {
      commissionType,
      typeValue,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Commission
const updateCommission = async (id, commissionType, typeValue) => {
  try {
    const response = await apiClient.put(`/commission/update/${id}`, {
      commissionType,
      typeValue,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get All Commissions
const getAllCommissions = async () => {
  try {
    const response = await apiClient.get(`/commission/get-all`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Add Settlement
const addSettlement = async (payload) => {
  try {
    const response = await apiClient.post(`/payment-settlement`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get All Settlements
const getAllSettlements = async () => {
  try {
    const response = await apiClient.get(`/payment-settlement`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Settlement By Id
const getSettlementsByVendorId = async (vendorId) => {
  try {
    const response = await apiClient.get(`/payment-settlement/${vendorId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Settlement
const updateSettlement = async (id, payload) => {
  try {
    const response = await apiClient.put(`/payment-settlement/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete Settlement
const deleteSettlement = async (id) => {
  try {
    const response = await apiClient.delete(`/payment-settlement/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Add FAQ
const addFAQ = async (faqData) => {
  try {
    const response = await apiClient.post(`/faqs/add`, faqData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update FAQ
const updateFAQ = async (id, faqData) => {
  try {
    const response = await apiClient.put(`/faqs/${id}`, faqData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete FAQ
const deleteFAQ = async (id) => {
  try {
    const response = await apiClient.delete(`/faqs/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get FAQs (with optional role filter)
const getFAQs = async (role) => {
  try {
    const response = await apiClient.get(`/faqs`, {
      params: role ? { role } : {},
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Add Distance
const addDistance = async (distance) => {
  const payload = { distance: Number(distance) }; // ensure number
  const response = await apiClient.post(`/distance/add-distance`, payload);
  return response.data;
};

//update distance
const updateDistance = async (id, distance) => {
  const payload = { distance: Number(distance) }; // ensure number
  const response = await apiClient.put(
    `/distance/update-distance/${id}`,
    payload
  );
  return response.data;
};

// Get Distance (single)
const getDistance = async () => {
  try {
    const response = await apiClient.get(`/distance/get-distance`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete Distance by ID
const deleteDistance = async (id) => {
  try {
    const response = await apiClient.delete(`/distance/delete-distance/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
const getLabel = async (params = {}) => {
  try {
    const response = await apiClient.get(`/label`, { params });
    return response;
  } catch (error) {
    throw error;
  }
};
const addLabel = async (faqData) => {
  try {
    const response = await apiClient.post(`/label/add`, faqData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update FAQ
const updateLabel = async (id, faqData) => {
  try {
    const response = await apiClient.put(`/label/${id}`, faqData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
const getLabelById = async (id) => {
  try {
    const response = await apiClient.get(`/label/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete FAQ
const deleteLabel = async (id) => {
  try {
    const response = await apiClient.delete(`/label/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
const cancelJobByAdmin = async (jobId) => {
  try {
    const response = await apiClient.post(`/jobs/cancel-job/${jobId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export {
  apiClient,
  login,
  logout,
  getCurrentUser,
  getDashOverview,
  getVendors,
  deleteVendor,
  getCustomers,
  deleteCustomer,
  updateUserStatus,
  // Equipment exports
  getEquipmentCategories,
  createEquipmentCategory,
  updateEquipmentCategory,
  deleteEquipmentCategory,
  getManufacturers,
  createManufacturer,
  updateManufacturer,
  deleteManufacturer,
  getVariants,
  createVariant,
  updateVariant,
  deleteVariant,
  // KYC exports
  getDoneVendorKyc,
  updateVendorKycStatus,
  getDoneEquipmentKyc,
  updateEquipmentKycStatus,
  // Job exports
  getAllJobs,
  addReferralDiscount,
  getDiscount,
  updateReferralDiscount,
  getAllReferrals,
  deleteReferralById,
  getAllPaidJobs,
  addCommission,
  updateCommission,
  getAllCommissions,
  addSettlement,
  getAllSettlements,
  updateSettlement,
  getSettlementsByVendorId,
  deleteSettlement,
  addFAQ,
  updateFAQ,
  deleteFAQ,
  getFAQs,
  addDistance,
  updateDistance,
  getDistance,
  deleteDistance,
  getLabel,
  addLabel,
  updateLabel,
  deleteLabel,
  getLabelById,
  newgetAllReferrals,
  newupdateReferralDiscount,
  updateAdminUser,
  cancelJobByAdmin,
};
